import React, { useState } from 'react'
import ContributionFilter from './ContributionsFilter'
import { Button, Form, InputNumber } from 'antd'
import { RebateAdjustApi, PostRebateAdjust } from '../../services/apiService'
import { showApiError , showApiSuccess} from '../utilities'
import "moment/locale/en-nz"
import moment from "moment"

export default function RebateAdjust(props) {
  const [data, setData] = useState([])
  const [search, setSearch] = useState({ fromDate: "", toDate: "", contId: 0 })

  let today = moment()
  let fromDate = moment().day(0)

  function handleSearch(search) {
    let querystring = `?from=${search.fromDate}&to=${search.toDate}&contId=${search.contId}&groupby=${search.groupBy}`
    //console.log(`${querystring}`)
    LoadData(querystring)
    setSearch(search)
  }

  function PostData(data) {

    //console.log("post data")
    PostRebateAdjust(data)
      .then(json => {
        if (typeof json === "string") {
          throw new Error(json);
        } else {
          //json 
          //console.log(json);
          showApiSuccess("Rebate adjustment applied.")
        }
      })
      .catch(error => {
        showApiError(error);
      });

  }


  function LoadData(querystring) {
    RebateAdjustApi(querystring)
      .then(json => {
        if (typeof json === "string") {
          throw new Error(json);
        } else {
          //json 

          setData(json)
        }
      })
      .catch(error => {
        showApiError(error);
      });

  }

  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 8 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 16 },
    },
  };

  function handleValueChanghe(value, index) {
    let item = { ...data[index], newPercentage: value }
    data[index] = item
    //console.log(data[index])

  }

  function handleSubmit(e) {
    //todo post data back to backend.
    e.preventDefault()
    let postData = {
      fromDate: moment(search.fromDate,"YYYYMMDD").format("YYYY-MM-DD"),
      toDate: moment(search.toDate, "YYYYMMDD").format("YYYY-MM-DD"),
      FundAdjustDTOs: data
    }
    //console.log(postData)
    PostData(postData)
  }



  function RenderFormItem() {
    return data.map((item, index) => {
      //console.log(`item.fund: {item.fund} `)
      return (<Form.Item key={index} label={item.fund}>
        <InputNumber max={100} min={0}
          defaultValue={item.newPercentage}
          onChange={e => handleValueChanghe(e, index)} />
      </Form.Item>)
    })
  }

  function ShowForm() {
    //console.log("run ShowForm")
    if (data.length > 0) {
      return (
        <Form {...formItemLayout} layout="horizontal" onSubmit={handleSubmit}>
          <Form.Item key="heading" label="Fund" colon={false}>
            <span >Rebate Percentage</span>
          </Form.Item>
          <RenderFormItem />
          <Form.Item key="apply" colon={false} label=" ">
            <Button icon="save" htmlType="submit" type="primary" >Apply</Button>
          </Form.Item>
        </Form>
      )
    }
    return null
  }
  return (
    <div className="content">
      <h2>{props.title}</h2>
      <ContributionFilter
        fromDate={fromDate}
        toDate={today}
        doSearch={handleSearch}
        groupBy={-1}
        button1Title='Get'
      />
      <ShowForm />
    </div>
  )

}

